<template>
  <v-container>
    <v-alert
      :value="true"
      type="info"
    >
      {{ messageValue }}
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: 'NoDataAvailableMessage',
  props: [
    'message'
  ],
  computed: {
    messageValue () {
      return this.message ? this.message : 'There is no data to show at this time.'
    }
  }
}

</script>
